import React, { useState } from "react";

import {
  Modal,
  Box,
  Typography,
  Slider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  IconButton,
  FormHelperText,
} from "@mui/material";

import { Cross } from "../../../shared/assets/icons";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import CustomInput from "../../../shared/utils/Input";
import GlobalButton from "../../../shared/utils/GlobalButton";
import { NewPlusIcon } from "../../../shared/assets/icons";

const ModalToCreateClusters = ({
  setOpenModalToCreateJobClusters,
  selectedBatches,
  openModalToCreateJobClusters,
  campaignData,
  setSelectedBatches,
  availableBatches,
  fetchAllJobsBasedOnCampaignId,
  productCategory,
  setSnackbar,
  // servicesNeeded = [],
}) => {
  const [servicesNeeded, setServicesNeeded] = React.useState([]);
  const [distance, setDistance] = useState(200); // Slider for Distance
  const [maxBatches, setMaxBatches] = useState(4); // Slider for Jobs
  const [createClusterLoading, setIsClusterLoading] = useState(false);
  // const [availableBatches, setAvailableBatches] = useState([]);
  const [availableClusters, setAvailableClusters] = useState([]);
  const [clusterDetails, setClusterDetails] = useState({
    paymentAmountPerSqFeet: null,
    startDate: "",
    endDate: "",
  });
  const [errors, setErrors] = useState({});

  const validateFields = () => {
    let newErrors = {};

    if (
      !clusterDetails.paymentAmountPerSqFeet ||
      clusterDetails.paymentAmountPerSqFeet <= 0
    ) {
      newErrors.paymentAmountPerSqFeet = "Payment Amount is required";
    }

    if (!clusterDetails.startDate) {
      newErrors.startDate = "Start date is required";
    }

    if (!clusterDetails.endDate) {
      newErrors.endDate = "End date is required";
    }

    // Ensure end date is not before start date
    if (
      clusterDetails.startDate &&
      clusterDetails.endDate &&
      clusterDetails.endDate < clusterDetails.startDate
    ) {
      newErrors.endDate = "End date cannot be earlier than start date";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };
  const [expandedBatch, setExpandedBatch] = React.useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] =
    React.useState(false);

  // styles :
  const tableCellStyle = {
    borderBottom: "1px solid #ddd",
    color: "#36383A",
    fontSize: "14px",
  };

  // handlers
  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setClusterDetails((prevData) => ({ ...prevData, [name]: value }));
  // };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setClusterDetails((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      // Validate end date when it's changed
      if (
        name === "endDate" &&
        updatedData.startDate &&
        value < updatedData.startDate
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          endDate: "End date cannot be earlier than start date",
        }));
      } else if (
        name === "startDate" &&
        updatedData.endDate &&
        updatedData.endDate < value
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          endDate: "End date cannot be earlier than start date",
        }));
      } else {
        setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          delete updatedErrors[name]; // Remove error for this field when valid
          return updatedErrors;
        });
      }

      return updatedData;
    });
  };

  const handleClose = () => setOpenModalToCreateJobClusters(false);
  // Modal styles
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%", // Adjusted width
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "8px",
  };

  React.useEffect(() => {
    if (selectedBatches.length > 0) {
      // let productsOfCampaign =
      //   selectedBatches[0]?.jobs[0]?.campaignId?.rfpId?.products;
      let productToSupply =
        selectedBatches[0]?.jobs[0]?.campaignId?.rfpId?.products.find(
          (product) =>
            product?.productType?.toLowerCase() ===
            selectedBatches[0]?.jobs[0]?.product?.productType.toLowerCase(),
        );
      setServicesNeeded(productToSupply.servicesNeeded);
    }
  }, [selectedBatches]);
  // React.useEffect(() => {
  //   if (campaignData._id) {
  //     fetchAllBatchesBasedOnCampaignId();
  //   }
  // }, []);
  // const fetchAllBatchesBasedOnCampaignId = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${serverURL}/batchOfJobs/getAllBatchJobs?campaignId=${campaignData._id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     );
  //     if (response?.data?.success) {
  //       setAvailableBatches(response.data.data);
  //     }
  //   } catch (error) {
  //     console.error("error in while fetching jobs", error);
  //   }
  // };
  const [saveButtonActive, setsaveButtonActive] = useState(true);

  const fetchAllClustersBasedOnBatches = async (e) => {
    e.preventDefault();
    if (!validateFields()) {
      console.log("Validation failed", errors);
      return;
    }
    const token = localStorage.getItem("token");

    // Determine serviceType based on servicesNeeded
    let serviceType = 0; // Default to 0 for both
    if (
      servicesNeeded?.includes("Fabrication") &&
      !servicesNeeded?.includes("Printing")
    ) {
      serviceType = 1;
    } else if (
      servicesNeeded?.includes("Printing") &&
      !servicesNeeded?.includes("Fabrication")
    ) {
      serviceType = 2;
    } else if (servicesNeeded?.includes("Painting")) {
      serviceType = 3;
    }

    try {
      setIsClusterLoading(true);
      const locations = selectedBatches.map((batch) => ({
        locationCoordinates: batch.centroidCoordinates,
        id: batch._id,
      }));
      const responseFromClusterAPI = await axios.post(
        `${process.env.REACT_APP_URL}/batchOfJobs/assignClusters`,
        {
          locationsToCreateClusters: locations,
          minLimitOfJobsInCluster: maxBatches,
          maximumDistance: distance,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (responseFromClusterAPI?.data.success) {
        setsaveButtonActive(false);
        setIsClusterLoading(false);
        const newClusters = await responseFromClusterAPI?.data?.clusters.map(
          (cluster, i) => {
            return {
              clusterTitle: `Cluster ${i + 1}`,
              jobCompletionDate: clusterDetails.endDate,
              jobStartingDate: clusterDetails.startDate,
              paymentAmountPerSqFeet: clusterDetails.paymentAmountPerSqFeet,
              serviceType: serviceType, // Set serviceType dynamically
              totalNumberOfJobs: cluster.jobs.reduce((total, job) => {
                const batch = selectedBatches.find(
                  (batch) => batch._id === job.id,
                );
                return total + (batch?.jobs?.length || 0);
              }, 0),
              centroidCoordinates: cluster.center,
              jobs: selectedBatches.filter((filterJob) =>
                cluster.jobs.some((job) => job.id === filterJob._id),
              ),
            };
          },
        );
        setAvailableClusters(newClusters);
      }
    } catch (error) {
      console.error("error in while fetching batches", error);
      setIsClusterLoading(false);
    }
  };
  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-GB"); // dd/mm/yyyy
  };
  const saveCreatedClusters = async () => {
    try {
      const token = localStorage.getItem("token");
      const responseFromSaving = await axios.post(
        `${process.env.REACT_APP_URL}/vendorClusterBatches/create`,
        {
          availableClusters,
          clusterDetails,
          campaignId: campaignData,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (responseFromSaving?.data.success) {
        setOpenConfirmationModal(false);
        setSelectedBatches([]);
        setOpenModalToCreateJobClusters(false);
        setSnackbar({
          open: true,
          message: "Cluster Created Successfully",
          severity: "success",
        });
        fetchAllJobsBasedOnCampaignId(campaignData);
      }
    } catch (error) {
      console.error("Error while saving created Clusters", error);
    }
  };
  return (
    <div>
      <Modal open={openModalToCreateJobClusters} onClose={handleClose}>
        <Box sx={modalStyle}>
          {/* Title */}
          <div className="flex justify-between">
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              {campaignData.campaignTitle}
            </Typography>
            <div className=" cursor-pointer" onClick={handleClose}>
              <Cross />
            </div>
          </div>
          {/* Tags */}
          <Box display="flex" gap={1} mb={3}>
            <Typography
              sx={{
                backgroundColor: "#E3F2FD",
                color: "#1E88E5",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "14px",
              }}
            >
              Supply
            </Typography>
          </Box>

          {/* Sliders */}
          <Box display="flex" gap={4} alignItems="center" mb={3}>
            <Box>
              <Typography>Distance for Vendor</Typography>
              <Slider
                value={distance}
                onChange={(e, value) => setDistance(value)}
                min={0}
                max={1000}
                valueLabelDisplay="auto"
              />
              <Typography>{distance} Km</Typography>
            </Box>
            <Box>
              <Typography>Maximum Batches in Cluster</Typography>
              <Slider
                value={maxBatches}
                onChange={(e, value) => setMaxBatches(value)}
                min={1}
                max={50}
                valueLabelDisplay="auto"
              />
              <Typography>{maxBatches} Batches</Typography>
            </Box>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} lg={6}>
              <CustomInput
                name="startDate"
                placeholder="Enter Start Date"
                title="Starting Date *"
                size="small"
                type="date"
                onChange={handleInputChange}
                value={clusterDetails?.startDate}
                error={errors.startDate}
                onBlur={(e) => {
                  // emptyInputCheck(e.target.name, e.target.value);
                  // if (saveButtonClicked) validateForm();
                }}
              />
              {errors.startDate && (
                <FormHelperText sx={{ color: "red" }}>
                  {errors.startDate}
                </FormHelperText>
              )}
            </Grid>

            <Grid item xs={12} sm={6} lg={6}>
              <CustomInput
                name="endDate"
                placeholder="Enter Last Date"
                title="Ending Date *"
                size="small"
                type="date"
                onChange={handleInputChange}
                value={clusterDetails?.endDate}
                error={errors.endDate}
                onBlur={(e) => {
                  // emptyInputCheck(e.target.name, e.target.value);
                  // if (saveButtonClicked) validateForm();
                }}
              />
              {errors.endDate && (
                <FormHelperText sx={{ color: "red" }}>
                  {errors.endDate}
                </FormHelperText>
              )}
            </Grid>

            <Grid item xs={12} sm={6} lg={6}>
              <CustomInput
                name="paymentAmountPerSqFeet"
                placeholder="Enter Payment (per sq. feet)"
                title="Payment (per sq. feet) *"
                type="number"
                size="small"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
                    handleInputChange(e);
                  }
                }}
                value={clusterDetails?.paymentAmountPerSqFeet}
                error={errors.paymentAmountPerSqFeet}
              />
              {errors.paymentAmountPerSqFeet && (
                <FormHelperText sx={{ color: "red" }}>
                  {errors.paymentAmountPerSqFeet}
                </FormHelperText>
              )}
            </Grid>
          </Grid>

          {availableClusters.length > 0 ? (
            <>
              <div className="flex justify-between items-center my-4">
                <Typography variant="h6" mb={2}>
                  Available Clusters : {availableClusters.length}
                </Typography>
                <div style={{ width: "200px" }}>
                  <GlobalButton
                    variant="primary"
                    size="medium"
                    isLoading={createClusterLoading}
                    onClick={(e) => fetchAllClustersBasedOnBatches(e)}
                    leftIcon={<NewPlusIcon />}
                  >
                    {` Create Clusters`}
                  </GlobalButton>
                </div>
              </div>
              <Grid
                container
                justifyContent="center"
                sx={{ overflow: "auto", maxHeight: "250px" }}
              >
                {availableClusters.map((cluster, index) => (
                  <Grid item xs={12} md={12} key={index} my={1} mx={2}>
                    <Accordion
                      expanded={expandedBatch === cluster.clusterTitle}
                    >
                      <AccordionSummary
                        expandIcon={
                          <IconButton
                            onClick={handleAccordionToggle(
                              cluster.clusterTitle,
                            )}
                          >
                            <ExpandMoreIcon />
                          </IconButton>
                        }
                        aria-controls={`panel-${index}-content`}
                        id={`panel-${index}-header`}
                      >
                        <div className="flex items-center justify-between p-4 rounded-lg bg-white w-full mx-auto">
                          {/* Section 1: Batch Title */}
                          <div className="flex">
                            <h1 className="text-lg font-bold">
                              {cluster.clusterTitle}
                            </h1>
                          </div>

                          {/* Section 2: Other Details */}
                          <div className="flex items-center gap-6">
                            <span>{`Total locations: ${cluster.totalNumberOfJobs}`}</span>
                            {/* Date Range */}
                            <Chip
                              className="text-sm"
                              style={{ color: "gray" }}
                              label={`${formatDate(cluster.jobStartingDate)} - ${formatDate(cluster.jobCompletionDate)}`}
                            />
                          </div>
                        </div>
                      </AccordionSummary>

                      <AccordionDetails>
                        {/* Render Job Details Table */}
                        <Box sx={{ overflow: "auto" }}>
                          <TableContainer
                            component={Paper}
                            sx={{
                              borderRadius: "1rem",
                              boxShadow: "none",
                              maxWidth: "100%",
                              overflowX: "auto",
                            }}
                          >
                            <Table sx={{ minWidth: 650, border: "none" }}>
                              <TableHead>
                                <TableRow
                                  sx={{
                                    backgroundColor: "#f9f9f9",
                                    borderRadius: "1rem",
                                  }}
                                >
                                  <TableCell sx={tableCellStyle}>
                                    Batch Title
                                  </TableCell>
                                  <TableCell sx={tableCellStyle}>
                                    Locations
                                  </TableCell>
                                  {/* <TableCell sx={tableCellStyle}>
                                    Job Pay
                                  </TableCell> */}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {cluster?.jobs?.map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell sx={tableCellStyle}>
                                      <div>{row.batchTitle}</div>
                                    </TableCell>
                                    <TableCell sx={tableCellStyle}>
                                      {row?.jobs?.length}
                                    </TableCell>
                                    {/* <TableCell sx={tableCellStyle}>
                                      ₹{row.paymentAmount}
                                    </TableCell> */}
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                ))}
              </Grid>
            </>
          ) : selectedBatches.length > 0 ? (
            <div>
              <div className="flex justify-between my-4 items-center">
                <Typography variant="h6">
                  Available Batches : {selectedBatches.length}
                </Typography>
                <div style={{ width: "200px" }}>
                  <GlobalButton
                    variant="primary"
                    size="medium"
                    isLoading={createClusterLoading}
                    onClick={(e) => fetchAllClustersBasedOnBatches(e)}
                    leftIcon={<NewPlusIcon />}
                  >
                    {`Create Clusters`}
                  </GlobalButton>
                </div>
              </div>
              <Box sx={{ overflow: "auto", maxHeight: "250px" }}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Batch Title</TableCell>
                        <TableCell>Total No. of Jobs</TableCell>
                        {/* <TableCell>Job Pay</TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedBatches.map((row) => (
                        <TableRow key={row._id}>
                          <TableCell>{row.batchTitle}</TableCell>
                          <TableCell>{row?.jobs?.length}</TableCell>
                          {/* <TableCell>{row.paymentAmount}</TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </div>
          ) : (
            <div>{`No available Batches`}</div>
          )}
          {/* Save and Edit Buttons */}
          <Box display="flex" justifyContent="end" mt={3}>
            <div style={{ width: "100px" }}>
              <GlobalButton
                variant="primary"
                size="small"
                disabled={saveButtonActive}
                onClick={() => {
                  setOpenConfirmationModal(true);
                }}
              >
                {`Save`}
              </GlobalButton>
            </div>
          </Box>
        </Box>
      </Modal>
      {openConfirmationModal && (
        <ConfirmationBeforeSaving
          saveCreatedClusters={saveCreatedClusters}
          setOpenConfirmationModal={setOpenConfirmationModal}
          openConfirmationModal
        />
      )}
    </div>
  );
};

export default ModalToCreateClusters;

const ConfirmationBeforeSaving = ({
  saveCreatedClusters,
  setOpenConfirmationModal,
  openConfirmationModal,
}) => {
  const [isSaving, setIsSaving] = React.useState(false);
  const [dots, setDots] = React.useState("");

  React.useEffect(() => {
    let interval;
    if (isSaving) {
      interval = setInterval(() => {
        setDots((prev) => (prev.length < 3 ? prev + "." : ""));
      }, 500);
    } else {
      setDots("");
    }
    return () => clearInterval(interval);
  }, [isSaving]);

  const handleClose = () => {
    if (!isSaving) setOpenConfirmationModal(false);
  };

  const handleSave = async () => {
    setIsSaving(true);
    await saveCreatedClusters();
    setIsSaving(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "25%", // Adjusted width
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "8px",
  };
  return (
    <Modal open={openConfirmationModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <div className="flex flex-col">
          <span>{`Are you sure you want to save following batches to make cluster ?`}</span>
          <div className="flex gap-2 mt-4 justify-end">
            <GlobalButton
              variant="secondary"
              size="small"
              onClick={handleClose}
              disabled={isSaving}
            >
              {`No thanks.`}
            </GlobalButton>
            <GlobalButton
              variant="primary"
              size="small"
              onClick={handleSave}
              isLoading={isSaving}
            >
              Yes, sure&nbsp;!
            </GlobalButton>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
